import styles from './admin-future-renewals-grid.module.scss';
import { useTableConfigHook } from '../../requestUtils';
import { booleanHeader, CreateHeaders, currencyHeader, dateHeader, HeaderSizeEnum, textHeader } from '@frontend-workspace/react-shared-lib';
import { IRenewalLicense } from '../../_models/future-renewals';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface FutureRenewalsGridProps {
  futureRenewals: IRenewalLicense[]
}

export function FutureRenewalsGrid(props: FutureRenewalsGridProps) {
  const { t } = useTranslation();
  //const licenses = props.futureRenewals.reduce((licenses: iRenewalLicense[], renwalContract: iFutureRenewals) => licenses.concat(renwalContract.licenses), []);
  const tableConfig = useTableConfigHook("futureRenewalsGrid");

  return (
    <WebkuaTable
      headers={CreateHeaders([
        textHeader("companyNumber", t("standard.companyNo"), HeaderSizeEnum.MEDIUM),
        textHeader("companyName", t("standard.company"), HeaderSizeEnum.EXTRA_LARGE),
        textHeader("productGroupName", t("standard.group"), HeaderSizeEnum.LARGE),
        textHeader("productName", t("standard.productName"), HeaderSizeEnum.LARGE),
        textHeader("recurringItem", t("standard.recurringItem"), HeaderSizeEnum.EXTRA_LARGE),
        textHeader("licenseType", t("standard.type"), HeaderSizeEnum.MEDIUM),
        textHeader("invoiceInterval", t("standard.invoiceInterval"), HeaderSizeEnum.LARGE, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("seats", t("standard.seats"), HeaderSizeEnum.MEDIUM, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        currencyHeader("oneTimeDiscount", t("standard.oneTimeDiscount"), HeaderSizeEnum.LARGE, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("recurringDiscountPercent", t("standard.discount"), HeaderSizeEnum.MEDIUM, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("vismaClient", t("standard.client"), HeaderSizeEnum.LARGE),
        currencyHeader("nextInvoiceCost", t("standard.nextInvoiceCost"), HeaderSizeEnum.LARGE, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        currencyHeader("acv", "ACV", HeaderSizeEnum.LARGE, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        currencyHeader("residualValue", t("standard.residualValue"), HeaderSizeEnum.LARGE, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        currencyHeader("recidualValueAtYearStart", t("standard.recidualValueAtYearStart"), HeaderSizeEnum.MEDIUM, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("invoiceMonth", t("standard.month"), HeaderSizeEnum.SMALL, {
          cellStyle: { justifyContent: 'right' },
          headerClass: "ag-right-aligned-header"
        }),
        textHeader("invoiceYear", t("standard.year"), HeaderSizeEnum.SMALL),
        dateHeader("nextInvoicingDate", "Neste fakturadato"),
        booleanHeader("isNewSale", "Nytt salg")
      ])}
      data={props.futureRenewals}
      tableConfig={tableConfig}
    />
  );
}

export default FutureRenewalsGrid;